<template>
  <CardsGrid :columns="2">
    <BaseCard v-for="role in roles" :key="role.key" class="text-center">
      <div class="w-12 h-12 bg-brand/10 rounded-full flex items-center justify-center mx-auto mb-4">
        <svg class="w-6 h-6 text-brand" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" :d="getRoleIcon(role.key)" />
        </svg>
      </div>
      <h3 class="text-xl font-semibold text-ink mb-3">{{ $t(role.title) }}</h3>
      <p class="text-muted">{{ $t(role.description) }}</p>
    </BaseCard>
  </CardsGrid>
</template>

<script setup lang="ts">
import BaseCard from './BaseCard.vue'
import CardsGrid from './CardsGrid.vue'
import { roles } from '@/data/roles'

// Role-specific icons mapping
const getRoleIcon = (key: string) => {
  const icons = {
    // Management - Chart/Dashboard icon
    'management': 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z',
    
    // Online Listing Managers - Edit/Content icon
    'listing-managers': 'M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z',
    
    // Inventory & Fulfillment - Package/Box icon
    'inventory-fulfillment': 'M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4',
    
    // Operations/Support - Support/Headset icon
    'operations-support': 'M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192L5.636 18.364M12 2.458V6m0 12v3.542M2.458 12H6m12 0h3.542'
  }
  return icons[key as keyof typeof icons] || icons['management']
}
</script>